import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withModifiers as _withModifiers, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "template-pane" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "template-title" }
const _hoisted_4 = { class: "preview-card" }
const _hoisted_5 = { class: "card-frame" }
const _hoisted_6 = { class: "card-overlay" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "preview-label" }
const _hoisted_10 = {
  key: 0,
  class: "display-flex justify-content-space-between align-items-center width100"
}
const _hoisted_11 = { class: "label-with-edit-icon" }
const _hoisted_12 = { class: "preview-label-text" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["src"]
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["src"]
const _hoisted_18 = ["minlength"]
const _hoisted_19 = ["src"]
const _hoisted_20 = ["src"]
const _hoisted_21 = {
  key: 2,
  class: "updated-preview-label"
}
const _hoisted_22 = {
  key: 0,
  class: "template-preview-overlay"
}
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "template-modal-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_ModalPopup = _resolveComponent("ModalPopup")!
  const _component_Toaster = _resolveComponent("Toaster")!
  const _component_EmailTemplateRenderer = _resolveComponent("EmailTemplateRenderer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_loading, {
      "show-loading": _ctx.showLoading,
      "border-color": _ctx.loaderBorderColor
    }, null, 8, ["show-loading", "border-color"]),
    (_ctx.modalPopupVisible)
      ? (_openBlock(), _createBlock(_component_ModalPopup, {
          key: 0,
          "show-modal-popup": _ctx.modalPopupVisible,
          "header-content": _ctx.modalPopupHeading,
          "body-heading": _ctx.modalPopupBodyHeading,
          "body-content": _ctx.modalPopupContent,
          "show-close-button": _ctx.showCloseButton,
          "show-cancel-button": _ctx.showCancelButton,
          "confirm-button-text": _ctx.buttonText,
          onConfirmClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.ConfirmClick($event)))
        }, null, 8, ["show-modal-popup", "header-content", "body-heading", "body-content", "show-close-button", "show-cancel-button", "confirm-button-text"]))
      : _createCommentVNode("", true),
    (_ctx.showToaster)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_Toaster, {
            message: _ctx.toasterMessage,
            "default-timeout": _ctx.toasterDefaultTimeout
          }, null, 8, ["message", "default-timeout"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("Invite.ConfigureEmails.ChangeTemplates")), 1),
    _createElementVNode("div", {
      class: _normalizeClass(["templates-grid", {'small-tab-display' : _ctx.isSmallTab}])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allEmailTemplates, (temp, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          key: temp.TemplateData.Id,
          class: "template-item"
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_EmailTemplateRenderer, {
                "template-data": temp,
                "fit-to-container": true
              }, null, 8, ["template-data"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                type: "button",
                class: "overlay-button preview-button",
                onClick: ($event: any) => (_ctx.OpenTemplatePreview(temp))
              }, _toDisplayString(_ctx.$t('Preview').toString()), 9, _hoisted_7),
              _createElementVNode("button", {
                type: "button",
                class: "overlay-button",
                onClick: ($event: any) => (_ctx.OpenApplyTemplateModal(temp))
              }, _toDisplayString(_ctx.$t('Invite.ConfigureEmails.ApplyTemplate').toString()), 9, _hoisted_8)
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", null, [
                (_ctx.editingIdx !== idx)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.GetTemplateLabel(temp.TemplateData, idx)), 1),
                        (temp.TemplateData.IsDefault !== true)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "edit-label-button",
                              onClick: ($event: any) => (_ctx.EditTemplateName(idx, temp.TemplateData))
                            }, [
                              _createElementVNode("img", {
                                src: _ctx.editIcon,
                                alt: "Edit"
                              }, null, 8, _hoisted_14)
                            ], 8, _hoisted_13))
                          : _createCommentVNode("", true)
                      ]),
                      (temp.TemplateData.IsDefault !== true)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "trash-icon",
                              onClick: ($event: any) => (_ctx.DeleteTemplateModal(temp.TemplateData.Id))
                            }, [
                              _createElementVNode("img", {
                                src: _ctx.trashIcon,
                                alt: "Delete"
                              }, null, 8, _hoisted_17)
                            ], 8, _hoisted_16)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.workingTemplate.TemplateData.TemplateName.$model) = $event)),
                        minlength: _ctx.templateNameMinLength,
                        class: _normalizeClass([_ctx.status(_ctx.v$.workingTemplate.TemplateData.TemplateName), "label-input"]),
                        type: "text"
                      }, null, 10, _hoisted_18), [
                        [
                          _vModelText,
                          _ctx.v$.workingTemplate.TemplateData.TemplateName.$model,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "icon-button round-outline",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.ChangeTemplateName(_ctx.v$)))
                      }, [
                        _createElementVNode("img", {
                          src: _ctx.tickIcon,
                          alt: "Save"
                        }, null, 8, _hoisted_19)
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "icon-button round-outline",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.CancelTemplateNameChanges && _ctx.CancelTemplateNameChanges(...args)))
                      }, [
                        _createElementVNode("img", {
                          src: _ctx.crossIcon,
                          alt: "Cancel"
                        }, null, 8, _hoisted_20)
                      ])
                    ], 64)),
                (temp.TemplateData.IsDefault !== true)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.$t('Invite.ConfigureEmails.LastUpdatedOn').toString()) + " " + _toDisplayString(_ctx.GetFormattedDate(temp.TemplateData.ModifiedOn)), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]))
      }), 128))
    ], 2),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.showPreview)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _createElementVNode("div", {
              class: "template-preview-dialog",
              onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("button", {
                class: "template-preview-close",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.ClosePreviewModal && _ctx.ClosePreviewModal(...args)))
              }, [
                _createElementVNode("img", {
                  src: _ctx.cardCrossIcon,
                  alt: "cross"
                }, null, 8, _hoisted_23)
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_EmailTemplateRenderer, {
                  "template-data": _ctx.workingTemplate,
                  "fit-to-container": false
                }, null, 8, ["template-data"])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]))
  ]))
}